import { render, staticRenderFns } from "./GuppyChatAudio.vue?vue&type=template&id=348ce2b5&"
import script from "./GuppyChatAudio.vue?vue&type=script&lang=js&"
export * from "./GuppyChatAudio.vue?vue&type=script&lang=js&"
import style0 from "./GuppyChatAudio.vue?vue&type=style&index=0&id=348ce2b5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports